export const validatePassword = (password: string, confirmPassword = "") => {
    if (!password) return 'Password is required';
    if (password.length < 8) return 'Password must be at least 8 characters';
    if (!/[A-Z]/.test(password)) return 'Password must contain at least one uppercase letter';
    if (!/[a-z]/.test(password)) return 'Password must contain at least one lowercase letter';
    if (!/[0-9]/.test(password)) return 'Password must contain at least one number';
    if (password !== confirmPassword) return 'Passwords do not match';

    return null;
};

export const validateEmail = (email: string) => {
    if (!email || !email.trim()) return 'Email is required';

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) return 'Please enter a valid email address';

    return null;
};

export const validateOrganisationName = (organisationName: string) => {
    if (!organisationName || !organisationName.trim()) {
        return 'Organisation name is required';
    }

    const trimmedName = organisationName.trim();
    if (trimmedName.length < 2 || trimmedName.length > 100) {
        return 'Organisation name must be between 2-100 characters';
    }

    return null;
};

export const validateEmailDomain = (domain: string) => {
    if (!domain || !domain.trim()) {
        return 'Domain is required';
    }

    const trimmedDomain = domain.trim();
    const domainRegex = /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*$/;

    if (!domainRegex.test(trimmedDomain)) {
        return `Invalid domain format: ${domain}`;
    }

    return null;
};

export const validateEmailDomains = (emailDomains: string[]) => {
    if (!emailDomains || !Array.isArray(emailDomains)) {
        return 'Email domains must be provided as an array';
    }

    const validDomains = emailDomains.filter(domain => domain && domain.trim());

    if (validDomains.length === 0) {
        return 'At least one email domain is required';
    }

    return null;
};

export const validateAdminEmailDomain = (adminEmail: string, emailDomains: string[]) => {
    if (!adminEmail || !emailDomains || !Array.isArray(emailDomains)) {
        return null; // Let other validators handle these cases
    }

    const validDomains = emailDomains
        .filter(domain => domain && domain.trim())
        .map(domain => domain.trim().toLowerCase());

    if (validDomains.length === 0) {
        return null; // Let domain validator handle this
    }

    const adminDomain = adminEmail.split('@')[1];
    if (adminDomain && !validDomains.includes(adminDomain.toLowerCase())) {
        return 'Admin email must use one of the provided email domains';
    }

    return null;
};

export const validateLabName = (labName: string) => {
    if (!labName || !labName.trim()) {
        return 'Lab name is required';
    }

    const trimmedName = labName.trim();
    if (trimmedName.length < 2 || trimmedName.length > 100) {
        return 'Lab name must be between 2-100 characters';
    }

    return null;
};

export const validateFTE = (fte: number) => {
    if (!fte) {
      return 'Total FTE is required';
    }
    if (isNaN(fte)) {
        return 'FTE must be a valid number';
    }
    if (fte <= 0) {
        return 'FTE must be greater than 0';
    }

    return null;
};

export const validateLabType = (labType: string) => {
    if (!labType || !labType.trim()) {
        return 'Lab type is required';
    }

    return null;
};

export const validateInvitationCode = (invitationCode: string) => {
    if (!invitationCode || !invitationCode.trim()) {
        return 'Invitation code is required';
    }

    const trimmedCode = invitationCode.trim();
    if (trimmedCode.length < 5 || trimmedCode.length > 32) {
        return 'This invitation code does not look valid';
    }

    return null;
};